<template>
  <div class="image-fit-wrap">
    <img
      class="image-fit"
      crossorigin="anonymous"
      :src="Img"
      alt=""
      srcset=""
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      Img: "",
    };
  },
  props: {
    imgUrl: {
      type: String,
      default: "",
    },
    width: {
      type: Number,
      default: 0,
    },
    height: {
      type: Number,
      default: 0,
    },
  },
  created() {
    this.Img = this.getContainImageUrl(this.imgUrl);
  },
  watch: {
    imgUrl() {
      this.Img = this.getContainImageUrl(this.imgUrl);
    },
    width() {
      this.Img = this.getContainImageUrl(this.imgUrl);
    },
    height() {
      this.Img = this.getContainImageUrl(this.imgUrl);
    },
  },
  methods: {
    getContainImageUrl(url) {
      if (!url || !this.width || !this.height) {
        return url || "";
      }

      if (!/^https?:\/\//.test(url)) {
        return url;
      }

      const [baseUrl, queryString] = url.split("?");
      const query = queryString
        ? queryString
            .split("&")
            .filter((param) => !param.startsWith("x-oss-process="))
            .join("&")
        : "";
      const cleanUrl = query ? `${baseUrl}?${query}` : baseUrl;
      const connector = cleanUrl.includes("?") ? "&" : "?";
      return `${cleanUrl}${connector}x-oss-process=image/resize,m_lfit,w_${this.width},h_${this.height}`;
    },
  },
};
</script>

<style scoped>
.image-fit-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-fit {
  display: block;
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
</style>
